import type { Cup } from "./types";

// Info panel for the focused cup, plus the cup-count badge and the
// "Back to shelf" button (which closes the panel from focus mode the
// same way the × and Esc do). Pulled out of hud.ts so the panel's DOM
// + subscriber wiring is one focused module.

export interface CupHud {
  setCount: (n: number) => void;
  showCup: (cup: Cup | null) => void;
  onClose: (cb: () => void) => void;
  setBackVisible: (visible: boolean) => void;
}

export function attachCupHud(): CupHud {
  const panel = document.getElementById("info-panel") as HTMLElement;
  const close = document.getElementById("info-close") as HTMLButtonElement;
  const series = document.getElementById("info-series") as HTMLElement;
  const name = document.getElementById("info-name") as HTMLElement;
  const location = document.getElementById("info-location") as HTMLElement;
  const notes = document.getElementById("info-notes") as HTMLElement;
  const count = document.getElementById("cup-count") as HTMLElement;
  const backButton = document.getElementById(
    "back-button",
  ) as HTMLButtonElement;

  const closeSubscribers: Array<() => void> = [];
  const closePanel = (): void => {
    panel.dataset.open = "false";
    panel.setAttribute("aria-hidden", "true");
    for (const cb of closeSubscribers) cb();
  };

  close.addEventListener("click", closePanel);
  backButton.addEventListener("click", closePanel);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closePanel();
  });

  return {
    setCount: (n) => {
      count.textContent = String(n);
    },
    showCup: (cup) => {
      if (!cup) {
        closePanel();
        return;
      }
      series.textContent = cup.series;
      name.textContent = cup.name;
      const loc = [cup.city, cup.country].filter(Boolean).join(", ");
      location.textContent = cup.year ? `${loc} · ${cup.year}` : loc;
      notes.textContent = cup.notes ?? "";
      panel.dataset.open = "true";
      panel.setAttribute("aria-hidden", "false");
    },
    onClose: (cb) => {
      closeSubscribers.push(cb);
    },
    setBackVisible: (visible) => {
      backButton.hidden = !visible;
    },
  };
}
